module.exports = __webpack_public_path__ + "media/images/gift-thanks-writer-bg-steak-14041e649189941e2611cd80c83c4020.png";